import { BaseRestResource } from "../../../../infrastructure/BaseRestResource";
import httpResource from "../../../core/infrastructure/httpResource";

class GreetingsResource extends BaseRestResource {
    constructor() {
        super(httpResource, 'mobile_assets/greetings');
    }
}

const greetingsResource = new GreetingsResource();

export default greetingsResource;